import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconGlobe';
/** Renders an SVG icon. */
const SvgGlobe = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M28 16c0-6.627-5.373-12-12-12S4 9.373 4 16s5.373 12 12 12 12-5.373 12-12m2 0c0 7.732-6.268 14-14 14S2 23.732 2 16 8.268 2 16 2s14 6.268 14 14"
      />
      <path
        fill="currentColor"
        d="M20 16c0-4.367-1.273-8.264-4-11.501-2.727 3.237-4 7.134-4 11.5 0 4.367 1.273 8.264 4 11.5 2.727-3.236 4-7.132 4-11.5Zm2 0c0 5.192-1.656 9.888-5.276 13.69a1 1 0 0 1-1.448 0C11.656 25.887 10 21.191 10 16s1.656-9.889 5.276-13.69l.074-.07a1 1 0 0 1 1.374.07C20.344 6.111 22 10.808 22 16"
      />
      <path
        fill="currentColor"
        d="M29 15a1 1 0 1 1 0 2H3a1 1 0 0 1 0-2zm-2.618-6.638C24.118 9.694 20.695 11 16 11S7.882 9.694 5.618 8.362l1.014-1.724C8.618 7.806 11.695 9 16 9s7.382-1.194 9.368-2.362zm0 15.276C24.118 22.306 20.695 21 16 21s-8.118 1.306-10.382 2.638l1.014 1.724C8.618 24.194 11.695 23 16 23s7.382 1.194 9.368 2.362z"
      />
    </svg>
  );
};
SvgGlobe.displayName = displayName;
export default SvgGlobe;
